
(function(){
  function slugify(str){
    return String(str || '')
      .toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g,'')
      .replace(/[^a-z0-9]+/g,'-')
      .replace(/^-+|-+$/g,'');
  }

  function initArticle(root){
    if (!root || root.dataset.msaInit === 'true') return;
    root.dataset.msaInit = 'true';

    const content = root.querySelector('.msa-content');
    const toc = root.querySelector('.msa-toc-links');

    if(content && toc){
      const headings = content.querySelectorAll('h2');
      toc.innerHTML = '';
      headings.forEach((heading, index) => {
        let id = heading.id;
        if(!id){
          id = slugify(heading.textContent) || ('section-' + (index + 1));
          let finalId = id, n = 2;
          while(document.getElementById(finalId)){
            finalId = id + '-' + n++;
          }
          heading.id = finalId;
          id = finalId;
        }
        const link = document.createElement('a');
        link.href = '#' + id;
        link.textContent = heading.textContent.trim();
        toc.appendChild(link);
      });
      if(!headings.length){
        const side = root.querySelector('.msa-toc');
        if(side) side.style.display = 'none';
      }
    }

    root.querySelectorAll('[data-copy-link]').forEach(btn=>{
      btn.addEventListener('click', function(e){
        e.preventDefault();
        navigator.clipboard?.writeText(window.location.href);
        const old = btn.textContent;
        btn.textContent = '✓';
        setTimeout(()=>btn.textContent = old,1200);
      });
    });

    if('IntersectionObserver' in window){
      const io = new IntersectionObserver(entries=>{
        entries.forEach(entry=>{
          if(entry.isIntersecting){
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },{threshold:.1});
      root.querySelectorAll('.msa-reveal').forEach(el=>io.observe(el));
    } else {
      root.querySelectorAll('.msa-reveal').forEach(el=>el.classList.add('is-visible'));
    }
  }

  document.addEventListener('DOMContentLoaded', ()=>document.querySelectorAll('.mialica-single-article').forEach(initArticle));
  document.addEventListener('shopify:section:load', e=>{
    const root=e.target.querySelector('.mialica-single-article') || (e.target.matches?.('.mialica-single-article') ? e.target : null);
    if(root) initArticle(root);
  });
})();
